// extracted by mini-css-extract-plugin
module.exports = {"myPosts":"MyPosts_myPosts__1Dm4o","posts":"MyPosts_posts__1OWwY"};